/*!
* @copyright
* Copyright(c) 2018 SICK AG
*/
const style = `* {
  box-sizing: border-box;
}

*,
:host {
  box-sizing: border-box;
  font-size: 1rem;
  font-family: inherit;
}

:host button,
:host input,
:host optgroup,
:host select,
:host textarea {
  font-family: inherit;
}

:host {
  display: inline-block;
  position: relative;
  outline: none;
  vertical-align: middle;
}
:host .column {
  position: relative;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
}
:host label:not(.unit) {
  font-size: 0.8571428571rem;
  color: var(--davinci-color-text,#2C3133);
  max-width: 88%;
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  font-family: inherit;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
:host .row {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  background-color: var(--davinci-color-background,#FFFFFF);
}
:host input {
  color: var(--davinci-color-text,#2C3133);
  background-color: var(--davinci-color-background,#FFFFFF);
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  border-radius: 0;
  font-family: inherit;
  font-size: 1rem;
  height: 3.2857142857rem;
  outline: none;
  text-overflow: ellipsis;
  width: 100%;
}
:host input::-moz-placeholder {
  color: var(--davinci-color-text-lighter,#737F85);
  font-family: inherit;
}
:host input:-ms-input-placeholder {
  color: var(--davinci-color-text-lighter,#737F85);
  font-family: inherit;
}
:host input::placeholder {
  color: var(--davinci-color-text-lighter,#737F85);
  font-family: inherit;
}
:host .unit {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  min-width: -webkit-fit-content;
  min-width: -moz-fit-content;
  min-width: fit-content;
  overflow-x: hidden;
  color: var(--davinci-color-secondary,#737F85);
}
:host .unit.suffix {
  padding-right: 0.8571428571rem;
}
:host .unit.prefix {
  padding-left: 0.8571428571rem;
}

:host([touch]) {
  width: 14.4285714286rem;
  min-width: 10.5rem;
}
:host([touch]) label:not(.unit) {
  line-height: 0.9285714286rem;
  padding-bottom: 0.8571428571rem;
}
:host([touch]) .row {
  align-content: flex-start;
  align-items: center;
  justify-content: flex-start;
  vertical-align: middle;
}
:host([touch]) davinci-button {
  flex: 0 0 auto;
  margin: 0;
  contain: layout;
}
:host([touch]) davinci-button[disabled]#decrease {
  border-right-color: var(--davinci-color-outline,#8E989D);
}
:host([touch]) davinci-button[disabled]#increase {
  border-left-color: var(--davinci-color-outline,#8E989D);
}
:host([touch]) .unit {
  height: 3.2857142857rem;
}
:host([touch]) .unit.suffix {
  padding-right: 1.1428571429rem;
}
:host([touch]) .unit.prefix {
  padding-right: 1.1428571429rem;
}
:host([touch]) input,
:host([touch]) .unit {
  border-width: 1px 0;
  border-style: solid;
  border-color: var(--davinci-color-outline,#8E989D);
}
:host([touch]) input {
  flex: 0 1 auto;
  padding: 0 1.1428571429rem;
  text-align: center;
}

:host([label]:not(.unit):not([touch])) {
  margin-top: 0.8571428571rem;
}

:host(:not([touch])) {
  border-width: 1px;
  border-style: solid;
  border-color: var(--davinci-color-outline,#8E989D);
  width: 9.4285714286rem;
}
:host(:not([touch])) label:not(.unit) {
  position: absolute;
  left: 6px;
  transform: translate(0, -70%);
  padding: 0 6px;
  background-color: var(--davinci-color-background,#FFFFFF);
}
:host(:not([touch])) input {
  border-width: 0;
  border-style: none;
  height: 3.1428571429rem;
  flex: 1 1 auto;
  min-width: 0;
  padding: 0 1.1428571429rem;
  background-color: var(--davinci-color-background,#FFFFFF);
}
:host(:not([touch])) .buttons {
  display: flex;
  flex-direction: column;
  flex: 0 0 auto;
}
:host(:not([touch])) button {
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  border-style: solid;
  border-color: var(--davinci-color-outline,#8E989D);
  padding: 0;
  width: 1.5714285714rem;
  height: 1.5714285714rem;
  -webkit-user-select: none;
     -moz-user-select: none;
      -ms-user-select: none;
          user-select: none;
  display: flex;
}
:host(:not([touch])) button davinci-icon {
  fill: var(--davinci-color-text-light,#50585C);
  width: 1.5rem;
  height: 1.5rem;
}
:host(:not([touch])) button:hover davinci-icon {
  fill: var(--davinci-color-primary,#007CC1);
}
:host(:not([touch])) button#increase {
  border-width: 0 0 1px 1px;
  background-color: var(--davinci-color-background,#FFFFFF);
}
:host(:not([touch])) button#decrease {
  border-width: 0 0 0 1px;
  background-color: var(--davinci-color-background,#FFFFFF);
}

:host([neutral]:not([touch])) button:hover davinci-icon {
  fill: var(--davinci-color-text,#2C3133);
}

:host(:not([bare]):not([touch])) {
  min-width: 5.5rem;
}

:host([bare]) {
  width: 7.8571428571rem;
  min-width: 3.9285714286rem;
}
:host([bare]) input {
  border-width: 1px;
}

:host([warn]) label:not(.unit) {
  color: var(--davinci-color-warning,#F5C413);
}

:host([touch][warn]) input,
:host([touch][warn]) #increase,
:host([touch][warn]) #decrease,
:host([touch][warn]) .unit {
  border-color: var(--davinci-color-warning,#F5C413);
}
:host([touch][warn]) #decrease {
  border-right-color: var(--davinci-color-outline,#8E989D);
}
:host([touch][warn]) #increase {
  border-left-color: var(--davinci-color-outline,#8E989D);
}

:host(:not([touch])[warn]) {
  border-color: var(--davinci-color-warning,#F5C413);
}

:host([error]) label:not(.unit) {
  color: var(--davinci-color-error,#EA0823);
}

:host([touch][error]) input,
:host([touch][error]) #increase,
:host([touch][error]) #decrease,
:host([touch][error]) .unit {
  border-color: var(--davinci-color-error,#EA0823);
}
:host([touch][error]) #decrease {
  border-right-color: var(--davinci-color-outline,#8E989D);
}
:host([touch][error]) #increase {
  border-left-color: var(--davinci-color-outline,#8E989D);
}

:host(:not([touch])[error]) {
  border-color: var(--davinci-color-error,#EA0823);
}

:host([touch]:focus:not([neutral])) label:not(.unit) {
  color: var(--davinci-color-primary,#007CC1);
}
:host([touch]:focus:not([neutral])) input,
:host([touch]:focus:not([neutral])) #increase,
:host([touch]:focus:not([neutral])) #decrease,
:host([touch]:focus:not([neutral])) .unit {
  border-color: var(--davinci-color-primary,#007CC1);
}
:host([touch]:focus:not([neutral])) #decrease {
  border-right-color: var(--davinci-color-primary,#007CC1);
}
:host([touch]:focus:not([neutral])) #increase {
  border-left-color: var(--davinci-color-primary,#007CC1);
}

:host([touch]:focus) label:not(.unit) {
  color: var(--davinci-color-text,#2C3133);
}
:host([touch]:focus) input {
  border-color: var(--davinci-color-primary,#007CC1);
}
:host([touch]:focus) #increase,
:host([touch]:focus) #decrease {
  border-color: var(--davinci-color-text,#2C3133);
}

:host(:not([touch]):focus[neutral]) {
  border-color: var(--davinci-color-outline,#8E989D);
}
:host(:not([touch]):focus[neutral]) label:not(.unit) {
  color: var(--davinci-color-text,#2C3133);
}

:host(:not([touch]):focus:not([neutral])) {
  border-color: var(--davinci-color-primary,#007CC1);
}
:host(:not([touch]):focus:not([neutral])) label:not(.unit) {
  color: var(--davinci-color-primary,#007CC1);
}

:host([readonly]:not([disabled])) input,
:host([readonly][touch]:not([disabled])) input,
:host([readonly]:not([touch]):not([disabled])) input {
  color: var(--davinci-color-text-light,#50585C);
}

:host([disabled]) input {
  background-color: var(--davinci-color-background,#FFFFFF);
}
:host([disabled]) .unit {
  border-color: var(--davinci-color-text-disabled,#B1B8BC);
}
:host([disabled]) input::-moz-placeholder {
  color: var(--davinci-color-text-disabled,#B1B8BC);
}
:host([disabled]) input:-ms-input-placeholder {
  color: var(--davinci-color-text-disabled,#B1B8BC);
}
:host([disabled]) label:not(.unit),
:host([disabled]) input,
:host([disabled]) input::placeholder {
  color: var(--davinci-color-text-disabled,#B1B8BC);
}
:host([disabled]) button {
  border-color: var(--davinci-color-text-disabled,#B1B8BC);
  background-color: var(--davinci-color-background,#FFFFFF);
}
:host([disabled]) button davinci-icon,
:host([disabled]) button:hover davinci-icon {
  fill: var(--davinci-color-text-disabled,#B1B8BC);
}

:host([disabled]:not([touch])) {
  border-color: var(--davinci-color-text-disabled,#B1B8BC);
}
:host([disabled]:not([touch])) input {
  border-color: var(--davinci-color-text-disabled,#B1B8BC);
}

:host([disabled][touch]) {
  border-color: var(--davinci-color-text-disabled,#B1B8BC);
}
:host([disabled][touch]) input,
:host([disabled][touch]) #increase,
:host([disabled][touch]) #decrease,
:host([disabled][touch]) .unit {
  border-color: var(--davinci-color-text-disabled,#B1B8BC);
}
:host([disabled][touch]) #decrease {
  border-right-color: var(--davinci-color-outline,#8E989D);
}
:host([disabled][touch]) #increase {
  border-left-color: var(--davinci-color-outline,#8E989D);
}

:host(:not([touch])) button[disabled] davinci-icon,
:host(:not([touch])) button[disabled]:hover davinci-icon {
  fill: var(--davinci-color-text-disabled,#B1B8BC);
}`;
export { style };
